import { render, staticRenderFns } from "./list-status.vue?vue&type=template&id=5fb70a56"
import script from "./list-status.vue?vue&type=script&lang=js"
export * from "./list-status.vue?vue&type=script&lang=js"
import style0 from "./list-status.vue?vue&type=style&index=0&id=5fb70a56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports